export default __webpack_public_path__ + "static/how-5fed3bb2b9ac0d141e0fc7c82fb1f81e.png";